<template>
  <v-menu
      v-model="showMenu"
      offset-y
      nudge-bottom="15px"
      nudge-left="300px"
      rounded="xl"
      style="max-width: 350px"
      right
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-show="!checkedPathsContracts"
          outlined
          class="rounded-xl"
          color="error"
          v-bind="attrs"
          v-on="on"
      >
        Отправить
        <v-icon small right>
          fa fa-info-circle
        </v-icon>
      </v-btn>
    </template>
    <v-card width="500px" max-height="450px" rounded="xl">
      <error-message
          v-show="checkBasicBid.length > 0"
          :error-messages="checkBasicBid"
          :title="'ЭК Ставка'"/>
      <error-message
          v-show="checkBasicHeadDepartment.length > 0"
          :error-messages="checkBasicHeadDepartment"
          :title="'ЭК Заведующий кафедрой'"/>
      <error-message
          v-show="checkBasicDean.length > 0"
          :error-messages="checkBasicDean"
          :title="'ЭК Декан'"/>
    </v-card>
  </v-menu>
</template>

<script>
import {mapGetters} from "vuex";
import errorMessage from "./ErrorMessage.vue";

export default {
  name: "TheDropdownListContractError",

  components: {
    errorMessage,
  },

  data() {
    return {
      showMenu: false,
    };
  },

  props: {
    checkedPathsContracts: Boolean,
  },

  computed: {
    ...mapGetters({
      checkBasicBid: "effective_contract/checkBasicBid",
      checkBasicHeadDepartment: "effective_contract/checkBasicHeadDepartment",
      checkBasicDean: "effective_contract/checkBasicDean",
    }),

  },
}
</script>

<style scoped>

</style>